module.exports = __webpack_public_path__ + "img/EmptyState.0cbcafd2.png";